import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from '@phosphor-icons/react';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button variant="ghost" className="mb-8 gap-2" onClick={() => navigate(-1)} data-testid="terms-back-btn">
          <ArrowLeft size={18} />
          Voltar
        </Button>

        <div className="space-y-8">
          <div>
            <h1 className="text-4xl font-bold tracking-tight mb-2">Termos de Uso</h1>
            <p className="text-sm text-muted-foreground">Ultima atualização: 11 de março de 2026</p>
          </div>

          <div className="prose prose-sm max-w-none space-y-6 text-muted-foreground leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Aceitação dos Termos</h2>
              <p>Ao acessar e utilizar a plataforma Aretê ("Plataforma"), disponível em aretesystem.com.br e seus subdomínios, você concorda integralmente com estes Termos de Uso. Caso não concorde com alguma disposição, solicitamos que não utilize nossos serviços.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. Descrição do Serviço</h2>
              <p>A Aretê é uma plataforma de gestão financeira pessoal que oferece:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Dashboard financeiro com gráficos e projeções</li>
                <li>Controle de receitas, despesas, metas e investimentos</li>
                <li>Quadro Kanban para gerenciamento de tarefas</li>
                <li>Bot integrado ao WhatsApp com inteligência artificial</li>
                <li>Relatórios financeiros personalizados</li>
                <li>Resumo diário automático via WhatsApp</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. Cadastro e Conta do Usuário</h2>
              <p>3.1. Para utilizar a Plataforma, é necessário criar uma conta fornecendo informações verdadeiras e atualizadas.</p>
              <p>3.2. O usuário é responsável por manter a confidencialidade de suas credenciais de acesso (email e senha).</p>
              <p>3.3. Cada conta é pessoal e intransferível. O compartilhamento de credenciais é proibido.</p>
              <p>3.4. Ao detectar qualquer uso não autorizado, o usuário deve notificar imediatamente o suporte em suporte@aretesystem.com.br.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Planos e Pagamento</h2>
              <p>4.1. A Plataforma oferece período de teste gratuito de 7 (sete) dias a partir do cadastro.</p>
              <p>4.2. Após o período de teste, o acesso será mantido mediante assinatura do plano vigente.</p>
              <p>4.3. Os pagamentos são processados de forma segura via Mercado Pago. A Aretê não armazena dados de cartão de crédito.</p>
              <p>4.4. O cancelamento pode ser solicitado a qualquer momento, mantendo o acesso até o final do período já pago.</p>
              <p>4.5. Os valores e condições dos planos podem ser alterados mediante aviso prévio de 30 dias.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. Uso da Integração WhatsApp</h2>
              <p>5.1. A integração com WhatsApp utiliza a API oficial da Meta (WhatsApp Business Cloud API).</p>
              <p>5.2. O usuário autoriza o envio e recebimento de mensagens relacionadas ao serviço ao vincular seu número.</p>
              <p>5.3. Os dados enviados via WhatsApp (texto, áudio e imagens) são processados para oferecer funcionalidades como registro de transações, transcrição de áudio e análise de recibos.</p>
              <p>5.4. O usuário pode desvincular seu número a qualquer momento nas configurações do perfil.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Uso de Inteligência Artificial</h2>
              <p>6.1. A Plataforma utiliza modelos de IA (incluindo GPT-4o e Whisper da OpenAI) para processamento de linguagem natural, análise de imagens e transcrição de áudio.</p>
              <p>6.2. As respostas geradas por IA são auxiliares e não constituem aconselhamento financeiro profissional.</p>
              <p>6.3. O usuário reconhece que resultados de IA podem conter imprecisões e deve validar informações importantes.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Responsabilidades do Usuário</h2>
              <p>7.1. Utilizar a Plataforma de acordo com a legislação vigente e estes Termos.</p>
              <p>7.2. Fornecer dados financeiros verídicos e precisos.</p>
              <p>7.3. Não utilizar a Plataforma para atividades ilícitas, fraudulentas ou que violem direitos de terceiros.</p>
              <p>7.4. Não tentar acessar áreas restritas, realizar engenharia reversa ou interferir no funcionamento da Plataforma.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">8. Limitação de Responsabilidade</h2>
              <p>8.1. A Aretê é uma ferramenta de gestão e não substitui consultoria financeira profissional.</p>
              <p>8.2. Projeções e estimativas são baseadas nos dados fornecidos e não garantem resultados financeiros.</p>
              <p>8.3. A Aretê não se responsabiliza por decisões financeiras tomadas com base nas informações da Plataforma.</p>
              <p>8.4. O serviço é fornecido "como está", sem garantias de disponibilidade ininterrupta.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">9. Propriedade Intelectual</h2>
              <p>9.1. Todo o conteúdo da Plataforma (código, design, marca, textos) é de propriedade exclusiva da Aretê.</p>
              <p>9.2. O usuário mantém a propriedade de seus dados pessoais e financeiros inseridos na Plataforma.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">10. Suspensão e Encerramento</h2>
              <p>10.1. A Aretê reserva-se o direito de suspender ou encerrar contas que violem estes Termos.</p>
              <p>10.2. Em caso de encerramento, o usuário poderá solicitar a exportação de seus dados em até 30 dias.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">11. Alterações nos Termos</h2>
              <p>11.1. Estes Termos podem ser atualizados a qualquer momento, com notificação aos usuários por email ou pela Plataforma.</p>
              <p>11.2. O uso continuado após alterações constitui aceitação dos novos termos.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">12. Legislação Aplicável</h2>
              <p>Estes Termos são regidos pela legislação brasileira. Fica eleito o foro da comarca de domicílio do usuário para dirimir eventuais controvérsias.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">13. Contato</h2>
              <p>Para dúvidas, reclamações ou solicitações relacionadas a estes Termos:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Email: <a href="mailto:suporte@aretesystem.com.br" className="text-primary hover:underline">suporte@aretesystem.com.br</a></li>
                <li>Site: <a href="https://aretesystem.com.br" className="text-primary hover:underline">aretesystem.com.br</a></li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
